import axios from 'axios'
import { axiosInterceptors, env } from '@accor/customer-core'

const axiosAem = axios.create({})

axiosInterceptors.urlInterceptor(axiosAem, env.generateGetter('apiAem'))

export default axiosAem
